import { appLanguageLabels } from "../../../utils/esim/broadcastStatus";
import { IMergeResult } from "../../../utils/esim/mergeBroadcastTranslations";

interface BroadcastTranslationsStatusProps {
  isStale: boolean;
  lastResult: IMergeResult | null;
  lastWarnings: string[];
  arrayError?: string;
}

// Everything the admin needs to know about the last generation, kept together above the rows.
//
// The persistent summary matters more than the toasts: partial success is normal here, toasts
// vanish in a few seconds, and "seven of ten languages came back" is exactly the state where the
// admin needs to re-read which languages still need writing by hand.
const BroadcastTranslationsStatus: React.FC<
  BroadcastTranslationsStatusProps
> = ({ isStale, lastResult, lastWarnings, arrayError }) => {
  return (
    <>
      {isStale && (
        <div className="rounded-lg bg-orange-50 border border-primary p-2 mb-3 text-xs">
          Mesazhi kryesor ka ndryshuar — përkthimet nuk përputhen me tekstin
          aktual. Kliko &quot;Rigjenero për të gjitha gjuhët&quot; për
          t&apos;i përditësuar.
        </div>
      )}
      {lastResult && (
        <div className="rounded-lg bg-gray-50 border p-2 mb-3 text-xs text-gray-600">
          {!!lastResult.appliedCodes.length && (
            <p>U plotësuan: {appLanguageLabels(lastResult.appliedCodes)}</p>
          )}
          {!!lastResult.keptCodes.length && (
            <p>
              Kishin tekst, u lanë siç ishin:{" "}
              {appLanguageLabels(lastResult.keptCodes)}
            </p>
          )}
          {!!lastResult.missingCodes.length && (
            <p className="text-warning">
              Nuk u gjenerua: {appLanguageLabels(lastResult.missingCodes)}
            </p>
          )}
          {lastWarnings.map((warning) => (
            <p key={warning} className="text-gray-500">
              {warning}
            </p>
          ))}
        </div>
      )}
      {arrayError && <p className="text-xs text-warning mb-2">{arrayError}</p>}
    </>
  );
};

export default BroadcastTranslationsStatus;
